$(document).ready(function () {
  let $projectHolder = $("#projects");
  let $recentProjectHolder = $(".recent-project-holder");
  let $modalContainer = $(".modalContainer");
  let $modalSlider = $(".modalSlider");

  let $previousProjectHolder = $(".previous-project-holder");
  let $listCursor = $(".list-cursor");
  let $listCursorLabel = $(".list-cursor-label");

  let xMoveContainer = gsap.quickTo($modalContainer, "left", {
    duration: 0.8,
    ease: "power3",
  });
  let yMoveContainer = gsap.quickTo($modalContainer, "top", {
    duration: 0.8,
    ease: "power3",
  });

  let xMovelistCursor = gsap.quickTo($listCursor, "left", {
    duration: 0.8,
    ease: "power3",
  });
  let yMovelistCursor = gsap.quickTo($listCursor, "top", {
    duration: 0.8,
    ease: "power3",
  });

  $recentProjectHolder.on("mousemove", function (e) {
    xMoveContainer(e.clientX);
    yMoveContainer(e.clientY);
  });
  $recentProjectHolder.on("mouseleave", function () {
    xMoveContainer(0);
    yMoveContainer(0);
  });

  $previousProjectHolder.on("mousemove", function (e) {
    xMovelistCursor(e.clientX);
    yMovelistCursor(e.clientY);
  });
  $previousProjectHolder.on("mouseleave", function () {
    xMovelistCursor(0);
    yMovelistCursor(0);
  });

  //each list
  $("div.project").on("mouseenter", function () {
    let index = $(this).data("index");

    // show modalContainer
    gsap.to($modalContainer, {
      scale: 1,
      opacity: 1,
      duration: 0.4,
      ease: "power3.out",
    });

    // slide modalSlider
    gsap.to($modalSlider, {
      y: -index * 100 + "%",
      duration: 0.4,
      ease: "power3.out",
    });
  });

  $("div.project").on("mouseleave", function () {
    // hide modalContainer
    gsap.to($modalContainer, {
      scale: 0,
      opacity: 0,
      duration: 0.4,
      ease: "power3.in",
    });
  });
  $("div.project, div.project-previous").on("click", function () {
    const link = $(this).data("link");
    if (link) {
      window.open(link, "_blank"); // Open in a new tab
    }
  });
  $("div.project-previous").on("mouseenter", function () {
    gsap.to($listCursor, {
      scale: 1,
      opacity: 1,
      duration: 0.4,
      ease: "power3.out",
    });
  });
  $("div.project-previous").on("mouseleave", function () {
    gsap.to($listCursor, {
      scale: 0,
      opacity: 0,
      duration: 0.4,
      ease: "power3.in",
    });
  });
});
